import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanDeactivateForm {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanDeactivateForm> {
  canDeactivate(component: CanDeactivateForm): boolean | Observable<boolean> {
    if (!component) {
      return true;
    }

    return component.canDeactivate() ? true : confirm('Existem alterações não salvas. Deseja continuar?');
  }
}
